<template>
    <div class="card-container">
        <common-table :data="tableData" ref="commonTable">
            <el-table-column
                prop="chnCode"
                label="通道代码"
                min-width="100"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="probability"
                label="概率（千分比）"
                min-width="100"
                show-overflow-tooltip
                :formatter="formatterTableData"
            >
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                min-width="100"
                show-overflow-tooltip
                :formatter="formatterEnable"
            >
            </el-table-column>
            <el-table-column
                prop="threshold"
                label="阀值百分比（百分比）"
                min-width="180"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                label="操作"
                min-width="120"
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="addInfo(scope.row)">修改</el-button>
                    <el-button type="text" @click="doStatus(scope.row)">{{scope.row.status == 1 ? '禁用' : '启用'}}</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="`通道代码： ${dialogModel.chnCode}`"
            :model="dialogModel"
            :dialogService="dialogService"
            :submitData="dialogData"
            class="over"
            @success="dialogSuccess"
            @close="dialogClose"
            labelWidth="250px"
        >
            <el-form-item label="概率（千分比）" prop="probability">
                <el-input-number
                    v-model="dialogModel.probability"
                    :min="0"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="阀值百分比（百分比）" prop="threshold">
                <el-input-number
                    v-model="dialogModel.threshold"
                    :min="0"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import SystemPropertiesService from "service/SystemPropertiesService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "systempropertiesmanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                tableData: [],
                dialogModel: {
                    probability: '',
                    chnCode: '',
                    threshold: '',
                },
                dialogService: SystemPropertiesService.meltEdit
            };
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.getList();
        },
        computed: {
            dialogData() {
                const params = {
                    probability: this.dialogModel.probability,
                    chnCode: this.dialogModel.chnCode,
                    threshold: this.dialogModel.threshold,
                    id: this.dialogModel.id,
                };
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        methods: {
            getList() {
                this.doLoad(SystemPropertiesService.meltList,
                    '',
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.tableData = result;
                        });
                    },
                    "信息获取失败"
                );
            },
            doStatus(item) {
                const _this = this;
                this.showConfirm('确认操作此通道？').then(() => {
                    _this.doLoad(SystemPropertiesService.meltEdit,
                        {
                            id: item.id,
                            status: item.status == 1 ? 0 : 1
                        },
                        (res) => {
                            this.doCheck(res, (res) => {
                                this.showSuccess(res.respMsg);
                                this.getList();
                            });
                        },
                        "信息获取失败"
                    );
                })
            },
            addInfo(item) {
                this.dialogModel = item;
                this.$nextTick(() => {
                    this.$refs.formDialog.open();
                })
            },
            dialogSuccess(res) {
                this.showSuccess(res.respMsg);
                this.$refs.formDialog.closeDialog();
                this.formModel = {};
                this.getList();
            },
            dialogClose() {
                this.dialogModel = {};
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/SystemPropertiesConfig.vue